module.exports = {
  "defaultCurrency": "USD",
  "currencies": [
    {
      "id": 2,
      "code": "USD",
      "name": "$USD",
      "change_store": true,
      "store": "27552866",
      "base_currency": "USD"
    }
  ]
}